import { render, staticRenderFns } from "./battery-detail.vue?vue&type=template&id=4e7cde12&"
import script from "./battery-detail.vue?vue&type=script&lang=js&"
export * from "./battery-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports